export default __webpack_public_path__ + "static/media/store1.51f59fb0.svg";